import Transition from '../Ticketdiv/components/tabcomponent/Transition';
import SearchComponent from '../Ticketdiv/components/searchcomponent/Searchcomponent';


const Meetingheader = ({
    setSearch,
    setSearching,
    searching,
    mode,
    setmode,
    search,
}) => {

  return (
   <div className="row" style={{ width: "100%", zIndex: "1", margin: "0px", textAlign: "center" }}>
                    <div className="col-md-12 col-12" style={{ position: "relative" }}>
                        <div className="row list__top__box">
                            <div className= { "col-12"} style={{ justifyContent:"space-between", paddingRight:"0px", display:"flex" , gap:"10px" , alignItems:"center"}}>

                                {
                                    !searching &&  <Transition istext="Completed" mode={mode} setmode={setmode}/>
                                }

                                    <div style={{width: searching && "100%"}}>
                                         <SearchComponent open={searching}  setOpen={setSearching} searchvalue={search} storeSearch={(data)=>{
    const val = data;
                                        setSearch(val);
}}/>
                                        </div>
                            </div>
                        </div>
                    </div>
                </div>
  )
}

export default Meetingheader